import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.marine,
  fillHoverColor: colors.marine,
  iconColor: colors.white,
  iconHoverColor: colors.auburn,
  iconBorderColor: colors.marine,
  iconBorderHoverColor: colors.navy
};
export default socialIcon;